// import { API } from 'aws-amplify';
import { initialExerciseProgress } from './initialExerciseProgress';
import { apiRequest } from '../util/apiRequest';
import { queryOptions } from '@tanstack/react-query';
import { assetsUrl } from '../util/constants';

const createUrl = (exerciseId, moduleId) => {
   const modulePath = moduleId ? `/${moduleId}` : '';

   return `/sync/exercise/${exerciseId}${modulePath}`;
};

export const exerciseGetSync = ({ exerciseId, moduleId }) =>
   Promise.resolve(
      JSON.parse(localStorage.getItem(createUrl(exerciseId, moduleId))) ||
         initialExerciseProgress
   );
// API.post('app', createUrl(exerciseId, moduleId)).then(
//    (exerciseData) => exerciseData || initialExerciseProgress
// );

export const exercisePutSync = ({ exerciseId, exerciseData, moduleId }) =>
   Promise.resolve(
      localStorage.setItem(
         createUrl(exerciseId, moduleId),
         JSON.stringify(exerciseData)
      )
   );
// API.post('app', createUrl(exerciseId, moduleId), {
//    body: exerciseData,
// });

const progressPathFromIds = (exerciseId, moduleId) => {
   if (moduleId) {
      return `/exercise/progress/${exerciseId}/${moduleId}`;
   }
   return `/exercise/progress/${exerciseId}`;
};

export const getExerciseProgress = (exerciseId, moduleId) =>
   apiRequest({
      path: progressPathFromIds(exerciseId, moduleId),
   });

export const putExerciseProgress = ({ exerciseId, moduleId, exerciseData }) =>
   apiRequest({
      path: progressPathFromIds(exerciseId, moduleId),
      method: 'PUT',
      body: exerciseData,
   });

const summaryPathFromIds = (exerciseId, moduleId) => {
   if (moduleId) {
      return `/exercise/summary/${exerciseId}/${moduleId}`;
   }
   return `/exercise/summary/${exerciseId}`;
};
export const getExerciseProgressSummary = (exerciseId, moduleId) =>
   apiRequest({
      path: summaryPathFromIds(exerciseId, moduleId),
   });

export const getAllExerciseProgressSummary = () =>
   apiRequest({
      path: '/exercise/summary',
   });

export const exerciseProgressSummaryOptions = () => {
   return queryOptions({
      queryKey: ['exerciseProgressSummary'],
      queryFn: getAllExerciseProgressSummary,
      staleTime: 1000 * 60 * 60 * 3,
      gcTime: 1000 * 60 * 60 * 3,
   });
};

export const exerciseListQueryOptions = () => {
   return queryOptions({
      queryKey: ['exerciseList'],
      queryFn: () => {
         return fetch(`${assetsUrl}/public/exercise/exerciseList.json`).then(
            (res) => res.json()
         );
      },
      staleTime: Infinity,
      gcTime: 1000 * 60 * 60 * 24,
   });
};
